<template>
  <v-container fluid>
    <v-row dense>
      <v-col class="text-h3 gray--text text--lighten-1">
        <span v-if="attendancePlace" class="font-weight-light">
          {{ attendancePlace.name }}
        </span>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <v-tabs background-color="transparent" color="gray">
          <authorization permissionKey="exams_queue" can="read">
            <v-tab to="identificacao" class="font-weight-bold">
              <PatientsCounter
                queueTitle="Identificação"
                queueType="exam_identification"
                :attendancePlaceId="attendancePlaceId"
              />
            </v-tab>
          </authorization>

          <authorization permissionKey="exams_queue" can="read">
            <v-tab to="aguardando" class="font-weight-bold">
              <PatientsCounter
                queueTitle="Aguardando"
                queueType="exam_waiting"
                :attendancePlaceId="attendancePlaceId"
              />
            </v-tab>
          </authorization>

          <authorization permissionKey="exams_queue" can="read">
            <v-tab to="dilatacao" class="font-weight-bold">
              <PatientsCounter
                queueTitle="Dilatação"
                queueType="therapy_exam"
                :attendancePlaceId="attendancePlaceId"
              />
            </v-tab>
          </authorization>

          <authorization permissionKey="exams_queue" can="read">
            <v-tab to="executando" class="font-weight-bold">
              <PatientsCounter
                queueTitle="Executando"
                queueType="exams"
                :attendancePlaceId="attendancePlaceId"
              />
            </v-tab>
          </authorization>
        </v-tabs>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <router-view :attendancePlaceId="attendancePlaceId" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PatientsCounter from "@/components/queues/attendance/patients_counter.vue";
export default {
  name: "exam",
  props: {
    attendancePlaceId: String,
  },
  components: {
    PatientsCounter,
  },
  apollo: {
    attendancePlace: {
      query: require("@/graphql/attendance_place/attendance_place.gql"),
      variables() {
        return {
          attendancePlaceId: this.attendancePlaceId,
        };
      },
    },
  },
};
</script>

<style lang="sass" scoped></style>
